import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-body-section',
  templateUrl: './main-body-section.component.html',
  styleUrls: ['./main-body-section.component.scss'],
})
export class MainBodySectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
